import { createColumnHelper } from '@tanstack/react-table';
import {
  CompanyColumnDefinitionCallbacks,
  getCompanyColumnDefinitions,
} from '../../v2-lead/components/table/company-column-definitions';
import { LeadFinderSecondaryTab } from '../../v2-lead/types';
// import {
//   getCompanyColumnDefinitions,
//   CompanyColumnDefinitionCallbacks,
// } from '../../../v2-lead/components/table/company-column-definitions';
// import { LeadFinderSecondaryTab } from '../../../v2-lead/types';

const NOOP_CALLBACKS: CompanyColumnDefinitionCallbacks = {
  onSaveCompany: () => {},
  onFindPeople: () => {},
  activeSubTab: LeadFinderSecondaryTab.SAVED,
  isFreePlanRestricted: false,
  onCompanyProfileClick: (company: any) => {
    const url = String(company?.website ?? '').trim();
    if (!url) return;
    if (typeof window === 'undefined') return;
    window.open(url, '_blank', 'noopener,noreferrer');
  },
};

// Maps COMPANY_EXPORT_GROUPS keys (API field keys) to company-column-definition IDs
const COMPANY_STATUS_KEY_ALIAS: Record<string, string> = {
  company_emails: 'company_email',
  company_phone_numbers: 'company_phone',
  social_urls: 'socials',
  description_enriched: 'company_description',
  followers_count_linkedin: 'linkedin_followers',
  company_size_range: 'employee_count',
  employees_count_by_department: 'employee_count_by_department',
  employees_count_by_seniority: 'employee_count_by_designation',
  active_job_postings_count: 'active_job_posting_count',
  key_executive_departures: 'key_executive_departure_name',
  key_executive_arrivals: 'key_executive_arrival_name',
  competitors: 'competitors_competitors',
  last_funding_round_name: 'last_funding_round',
  last_funding_round_amount_raised: 'last_raised_amount',
  last_funding_round_announced_date: 'last_funding_date',
  funding_rounds: 'funding_rounds_name',
  technologies_used: 'technologies',
  total_website_visits_monthly: 'website_visitor_count',
  visits_breakdown_by_country: 'website_visitor_count_by_country',
  visits_breakdown_by_gender: 'website_visitor_count_by_gender',
  product_reviews_score: 'product_review_score',
  employee_reviews_score: 'employee_review_score',
  stock_information: 'stock_currency',
};

const columnHelper = createColumnHelper<Record<string, any>>();

export function buildCompanyStatusColumns(apiColumns: string[]) {
  const sourceDefs = getCompanyColumnDefinitions(NOOP_CALLBACKS) as any[];
  const defMap = new Map<string, any>();
  sourceDefs.forEach((def: any) => {
    if (def?.id) defMap.set(def.id, def);
  });

  return apiColumns
    .map((key) => {
      const defId = COMPANY_STATUS_KEY_ALIAS[key] ?? key;
      const def = defMap.get(defId);
      if (!def) return null;

      const { cell: originalCell } = def;
      return columnHelper.display({
        id: key,
        header: def.header,
        size: def.size ?? 180,
        cell: ({ row, ...ctxRest }: any) => {
          // Inject isEnriched: true to suppress EnrichmentTeaserCell
          const original = row?.original ?? {};

          const {
            employee_reviews: er,
            employee_review: erv,
            employee_reviews_score: ers,
          } = original;

          const withCompanyFields = {
            ...original,
            website: original.website,
            company_logo_url: original.company_logo_url ?? original.logo_url,
          };

          const patchedOriginal =
            key === 'employee_reviews_score'
              ? {
                  ...withCompanyFields,
                  employee_reviews: er ?? ers,
                  employee_review: erv ?? ers,
                }
              : withCompanyFields;

          const isRowRevealing = Boolean(patchedOriginal.isRevealing);

          const patchedCtx = {
            ...ctxRest,
            row: {
              ...row,
              original: {
                ...patchedOriginal,
                isEnriched: !isRowRevealing,
              },
            },
          };
          return originalCell(patchedCtx);
        },
      });
    })
    .filter(Boolean);
}
